"use strict";

import Page from "./Ticket.jsx";

export const auth = true;
export const title = "i18n:ticket.pageTitle";
export const Component = Page;
